import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04f85ea9"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=04f85ea9&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f85ea9')) {
      api.createRecord('04f85ea9', component.options)
    } else {
      api.reload('04f85ea9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04f85ea9", function () {
      api.rerender('04f85ea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/reportes/interaccion_sin_watson/index.vue"
export default component.exports